// @ts-ignore loading the URL for the vibes css
import VibesHostURL from "../../configuration/entrypoint-linker-loader?entryPoint=vibes_host&assetType=js!";

/* @ts-ignore: A current TS setting requires every file to be an exported module, but this file should be an iife */
export function loadVibes(vibesUrl: string, vibesHostFileName: string, doc: Document): void {
    console.log("Vibes Host Script is loading");
    const scriptTag = doc.createElement("script");
    scriptTag.setAttribute("type", "module");
    scriptTag.setAttribute("src", `${vibesUrl}/${vibesHostFileName}`);
    const appendTo = doc.getElementsByTagName("head")[0];
    appendTo.appendChild(scriptTag);
}

let wasLoaded = false;

(function () {
    if (!wasLoaded) {
        // we leverage the .env plugin (https://www.npmjs.com/package/dotenv-webpack) inorder to code VIBES_WEBSITE_HOST.
        // This will load the value in at compile time and keep it as a static string
        loadVibes("{{CloudFrontProtocol}}://{{CloudFrontDomain}}",
            VibesHostURL,
            document
        );
        wasLoaded = true;
    }
})();

